import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesPriceListsView } from "src/components/views/erp/sales/pricing/salesPriceLists/SalesPriceListsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/pricing/priceLists")({
	staticData: { title: i18n.t("price_lists"), legacyViewKey: "salesPriceListsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesPriceListsView />;
}
